import { createEmotionCache } from "@mantine/core";

export const emotionCache = createEmotionCache({
  key: "mantine-emotion-cache",
});
